import { Dialog, DialogBody, DialogTitle } from '@/components/base/dialog'
import { Query } from './dialog_query'
import { FeatureRequestsQuery } from './__generated__/dialog_query'
import { useQuery } from '@apollo/client'
import { Inline as Error } from '@/components/error'
import { Inline as Loading } from '@/components/loading'
import { FeatureRequest } from './feature_request'

interface Props {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export const ChangelogDialog = ({ open, setOpen }: Props) => {
  const { loading, error, data } = useQuery<FeatureRequestsQuery>(Query, {})

  if (error) { return <Error message={error.message} /> }
  if (loading || !data) { return <Loading /> }

  return (
    <Dialog open={open} size="5xl" onClose={setOpen}>
      <DialogTitle>
        <div className="flex flex-col gap-2 items-center justify-around">
          <span className="text-xl">What's new</span>
          <p className="text-center">
            We're always busy working on new things, here's just a summary of
            the recent changes we've made
          </p>
          <p className="text-center">
            Got an idea for something you'd like
            to see on this list? Drop us a line at &nbsp;
            <a href="mailto:support@rippleassetmanagement.co.uk">support@rippleassetmanagement.co.uk</a> with
            your thoughts and we'll see what we can do
          </p>
        </div>
      </DialogTitle>
      <DialogBody>
        <div className="grid grid-cols-2 gap-6">
          { data.releasedFeatureRequests.nodes
            .filter(fr => fr.state == 'released').slice(0, 5)
            .map(fr => <FeatureRequest featureRequest={fr} />) }
          { data.betaFeatureRequests.nodes
            .filter(fr => fr.state == 'beta').slice(0, 3)
            .map(fr => <FeatureRequest featureRequest={fr} />) }
          { data.startedFeatureRequests.nodes
            .filter(fr => fr.state == 'started').slice(0, 2)
            .map(fr => <FeatureRequest featureRequest={fr} />) }
          { data.plannedFeatureRequests.nodes
            .filter(fr => fr.state == 'planned').slice(0, 2)
            .map(fr => <FeatureRequest featureRequest={fr} />) }
        </div>
      </DialogBody>
    </Dialog>
  )
}
